import * as React from "react";

import "./advanced-search-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

import {AdvanceForm} from "../advance-form/advance-form";
import {OmniSearch}  from "../common/omni-search/omni-search";

export const AdvancedSearchModal = ({tags, freeText, next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3({
        xdQaName: "Advanced Search Modal",
        rootNext,
        width: 382,
        next,
        xToClose: false,
    })],
    ({modal}) => (
        <div className="modal-layout-89b">
            <div className="top">
                {OmniSearch({
                    tags,
                    freeText,
                })}
            </div>
            <div className="main">
                {AdvanceForm({
                    onClose: modal.close,
                    tags,
                    forceSearchable: freeText.value != "",
                    isMobile: true,
                })}
            </div>
        </div>
    )
);
